import { Component, OnInit } from '@angular/core'
import { CheckoutCostCenterFacade } from '@spartacus/checkout/b2b/root'
import { CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root'
import { UserCostCenterService } from '@spartacus/core'
import { CheckoutCostCenterComponent } from '@spartacus/checkout/b2b/components'

@Component({
    selector: 'app-custom-cost-center',
    templateUrl: './custom-cost-center.component.html',
    styleUrls: ['./custom-cost-center.component.scss'],
    standalone: false
})
export class CustomCostCenterComponent extends CheckoutCostCenterComponent implements OnInit {
  constructor(
    protected userCostCenterService: UserCostCenterService,
    protected checkoutCostCenterFacade: CheckoutCostCenterFacade,
    protected checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade
  ) {
    super(userCostCenterService, checkoutCostCenterFacade, checkoutPaymentTypeFacade)
  }

  ngOnInit() {
    // super.ngOnInit();
  }
}
